/*
    Description: main search class -- click search icon and show overlay to search for content on our site 
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

//import utility class for ajax call
import Utilities from "./utilities";

//Search class
class Search extends Utilities{
    
    // contructor
    constructor(){

        // get constructor/params from Utilities
        super();
        
        // set selectors
        this.footerMsgSelector = "modal__wrapper__footer__messages";
        this.footerLoadingBar = "modal__wrapper__footer__loadingbar__bar";
        this.searchErrorDiv = "search__msg";
        this.formSelector = "search__modal";
        this.searchBttnID = "search__submit";
        this.searchInput = "search__term";
        this.searchIcon = "search__logo";
        this.shadowClassName = "--search-shadow";
        this.loadingClassName = "--loading";
        this.successClassName = "--success";
        this.errorClassName = "--error";
        this.closeClassName = "--close";

        // set search overlay title
        this.title = "Search";

        // set submit button label
        this.submitBttnLabel = "Search";

        // result ul class name
        this.resultsUlClassName = "modal__wrapper__footer__messages__ul";

        // get search icon selector
        this.search = document.querySelector(`.${this.searchIcon}`);

        // get nonce element 
        this.nonce = document.getElementsByName("nav-search");

        // error fallback msg
        this.fallbackError = "API ERROR: Something went wrong. Please try again later.";

        // no results msg 
        this.noResultsMsg = 'Sorry we could not find any matches for "{{term}}".';
        this.tryDifferentTermMsg = 'Please try a different search term.';

    }

    //set search overlay title
    setTitle(){

        // return title
        return (this.title) ? this.title : null;
        
    }

    //set search overlay body(form)
    setBody(){

        // setup tags
        const tags = `
            <div class="search__wrapper">
                <form class="search__wrapper__form">
                    <div class="search__wrapper__form__row">
                        <div class="search__wrapper__form__row__input">
                            <input id="search__term" class="--search-shadow" name="search" placeholder="Search For..." autocomplete="off" aria-label="Please enter a search term">
                            <div class="search__msg" aria-hidden="true" aria-label='search output message area'></div>
                        </div>
                    </div>
                    <div class="search__wrapper__form__row">
                        <div class="subscribe__form__row__input">
                            <button id="${this.searchBttnID}" class="--search-shadow" role="button" aria-label="Search Button: Click here to submit a search">Search</button>
                        </div>
                    </div>
                </form>
            </div>
        `;

        // return 
        return tags;

    }

    // method to decode html entities inside a string
    decodeEntities(val){

        // create p tag
        const p = document.createElement('p');
        
        // get the inneer html 
        p.innerHTML = val;

        // return copy
        return p.textContent;

    }

    // process search
    processSearch(e){

        // prevent default
        e.preventDefault();

        // set clicked button var 
        const thisBttn = e.target; 

        // add loading icon
        thisBttn.classList.add(this.loadingClassName);

        // check for modal and try to get form
        const modal = document.querySelector(`.${this.formSelector}`),
            form = (modal) ? modal.getElementsByTagName("form")[0] : null,
            searchInput = (form) ? form.querySelector(`#${this.searchInput}`) : null;

        // make sure form exists
        if(form != null){

            // init search value
            const searchValue = (searchInput) ? searchInput.value : null;

            // trim starting quote
            let trimmedQuotes = ((searchValue)&&(searchValue.charAt(0) === "'" || searchValue.charAt(0) === '"')) ? searchValue.slice(1) : searchValue;
            
            // trim last quote
            trimmedQuotes = ((trimmedQuotes)&&(trimmedQuotes.charAt(trimmedQuotes.length - 1) === "'" || trimmedQuotes.charAt(trimmedQuotes.length - 1) === '"')) ? trimmedQuotes.slice(0, -1) : trimmedQuotes;

            // get search term
            const searchTerm = (trimmedQuotes) ? trimmedQuotes.replace(/[^A-Za-z0-9\-\—\_\:\;\$\&\(\)\,\'\. ]/g, "") : null;
            
            // get footer general msg area and get searchMsg area
            const footerMsg = modal.querySelector(`.${this.footerMsgSelector}`),
                closeBttn = modal.querySelector(`.${this.closeClassName}`),
                searchMsg = form.querySelector(`.${this.searchErrorDiv}`);

            // make sure searchMsg and footer msg area exists - or display error and die
            if(!searchMsg || !footerMsg){

                //set which error to show
                const missingElement = (!searchMsg) ? this.footerMsgSelector : this.searchErrorDiv;

                // display error msg
                console.log(`%c Error: Could not find the element using the selector: '.${missingElement}'!!!`, 'background:#f00; color:#fff');
                return;

            }

            // reset search error msg area
            searchMsg.textContent = "";

            //reset footerMsg
            footerMsg.innerHTML = "";            

            // init const
            const thisLoadingBar = modal.querySelector(`.${this.footerLoadingBar}`),        // try to grab loading bar area
                data = new FormData(),                                                      // setup form data
                msg = document.createElement("div"),                                        // create msg element
                p = document.createElement("p");                                            // create paragraph tag
            
            // append data
            data.append("search__term", searchTerm);

            // make sure we have data
            if(this.nonce && this.nonce[0]) data.append("wp_nonce", this.nonce[0].value);
            
            // reset footer msg
            footerMsg.classList.remove(this.successClassName, this.errorClassName);

            // add accessibility attributes
            footerMsg.setAttribute("role", "feed")
            footerMsg.setAttribute("aria-busy","false");
            footerMsg.setAttribute("aria-label","Your search results");

            // send ajax
            this.ajax({
                action:"searchResults",                                     //go to "searchResults" ajax method
                data:data,                                                  //form data passed
                loadingBar:(thisLoadingBar) ? thisLoadingBar : null,        //loading bar element
                loading:thisBttn                                            //bttn we clicked (to pass loading gif)
            }).then((results) => {
   
                //parse results
                results = JSON.parse(results);

                //reset footerMsg
                footerMsg.innerHTML = "";  

                // SUCCESS: get 
                if(results.success){
                    
                    // SUCCESS: we have results to show
                    if(results.success.length > 0){

                        // get footer wrapper index
                        let footerIndex = ((footerMsg.getAttribute("tabindex") * 1) + 1);

                        // create ul element
                        const ul = document.createElement("ul");

                        // add class to ul
                        ul.classList.add(this.resultsUlClassName, this.shadowClassName);

                        // LOOP: look thru individual result items
                        results.success.forEach((item) =>{

                            // add attributes/styles to elements
                            if(item.link && item.title){
                                
                                // create li element and anchor element
                                const li = document.createElement("li"),
                                    a = document.createElement("a"),
                                    span = document.createElement("span"),
                                    text = this.decodeEntities(item.title);

                                    // add content to span
                                    span.append(item.type); 

                                    // set href
                                    a.setAttribute("href", item.link);
                                    
                                    // set target to self
                                    a.setAttribute("target", "_self");

                                    // add title tag
                                    a.setAttribute("title", `Click here to read more about '${text}'. This is a ${item.type} article.`);

                                    // set tabindex
                                    a.setAttribute("tabindex", footerIndex++);

                                    // add anchor copy                                    
                                    a.append(`${text}`);
                                    
                                // add anchor to li
                                li.appendChild(a); 

                                // add span to li
                                li.appendChild(span);

                                // add li to our ul
                                ul.appendChild(li);
                                
                            }

                        });

                        // add results ul to DOM
                        if(ul.children.length > 0) footerMsg.appendChild(ul);

                        // update close button tavindex
                        closeBttn.setAttribute("tabindex", footerIndex++);

                    // ERROR: search yielded zero returns
                    }else{

                        // add success class
                        msg.classList.add("--error");

                        // setup msg
                        let noResultMsg = this.noResultsMsg.replace("{{term}}", searchTerm);

                        // add text to p
                        p.textContent = noResultMsg;
                        
                        // add second p to ask user to try again
                        const p2 = document.createElement("p");
                        
                        // add copy to try another term
                        p2.textContent = this.tryDifferentTermMsg;

                        // add content to element
                        msg.appendChild(p);
                        msg.appendChild(p2);

                    }
                    
                // ERROR:display msg
                }else{
                    
                    // add error class
                    msg.classList.add("--error");

                    // ERROR FOUND: display error
                    if(results.error){

                        // add text to p
                        p.textContent = results.error.search__term;

                        // add content to element
                        msg.appendChild(p);                 

                    // ERROR: fallback
                    }else{

                        // add text to p
                        p.textContent = this.fallbackError;

                        // add content to element
                        msg.appendChild(p);    

                    }

                }

                // add msg to DOM
                footerMsg.appendChild(msg);
                
            // catch ajax error
            }).catch((err) => {
                
                // add error class
                msg.classList.add("--error");
                
                // add text to p
                p.textContent = err;

                // add content to element
                msg.appendChild(p);  

                // add to DOM
                footerMsg.appendChild(msg);

            });

        // ERROR
        }else{

            // display error msg
            console.log(`%c Error: Could not find the form!!!`, 'background:#f00; color:#fff');

        }

    }

    // add event listener to search bttn
    submit(){
        
        // get form submit button
        const modal = document.querySelector(`.${this.formSelector}`),
            searchBttn =  modal.querySelector(`#${this.searchBttnID}`);

        // make sure searchBttn exists
        if(searchBttn){

            // add event listener
            searchBttn.addEventListener("click", this.processSearch.bind(this));

        // ERROR
        }else{

            // display error msg 
            console.log(`%c Error: Could not find the element using the selector: '#${this.searchBttnID}'!!!`, 'background:#f00; color:#fff');

        }

    }

}

// export
export default Search;